<script>
  import Carto from "./Carto.svelte"
  import Resizer from "$lib/components/guardian/Resizer.svelte"
  import { getURLParams } from "$lib/helpers/guardian/toolbelt.js"
  import { onMount } from "svelte"
  import {
    state,
    googleSheetData,
    setGoogleSheetKey,
    setGoogleSheetSheetName,
  } from "$lib/stores/googlesheet.svelte.js"

  onMount(async () => {

    const key = getURLParams("key") ? getURLParams("key") : "1An44zBLKvOC5dmjfQ4voYHwv7ZB-uGmbhH6tOCTwSxM" ;
    const sheet = getURLParams("sheet") ? getURLParams("sheet") : "Sheet1" ;
    const theme = getURLParams("theme") ? getURLParams("theme") : false ;

    if (theme == 'dark') {
      document.querySelector("body").classList.add("dark-mode-on")
    }

    setGoogleSheetKey(key)
    setGoogleSheetSheetName(sheet)

    await googleSheetData()
  })

  const defaultGeoJsonStyles = [
    {
      id: "geojson-outline",
      type: "line",
      source: "overlays",
      paint: {
        "line-color": "#1e88e5",
        "line-width": 2,
      },
    },
    {
      id: "geojson-fill",
      type: "fill",
      source: "overlays",
      paint: {
        "fill-color": "#1e88e5",
        "fill-opacity": 0.35,
      },
    },
  ]

  let { name, geoJsonURL = "", geoJsonStyles = defaultGeoJsonStyles } = $props()

  $inspect(state.mapdata)
</script>

<Resizer atomName="#{name}" />

{#if state.mapdata.length > 0}
  <Carto
    mapdata={state.mapdata}
    legend={state.legend}
    popupTemplate={state.popupTemplate}
    {geoJsonStyles}
    MAP_INTERACTIVE={true}
    headline={state.headline}
    subtitle={state.subtitle}
    source={state.source}
  />
{/if}

<style lang="scss">
</style>
